<template >
  <div style="padding:0 0 16px 0">
    <Record v-if="record.id" :record="record" @cancel="record = {}" />
    <div v-else>
      <a-row>
          <div style="display: flex;align-items: center">
            <a-col :span="16">
                <div class="form-group-list">
                    <SelectField label="管网" id="type"
                                 :modelValue="form.category" :options="typeList" style="width: 35%"
                                 @update:modelValue="(value) => handleModelValueUpdate('category', value)"
                    />
                    <InputField style="width:30%;" label="编号" type="text" id="name"
                                :modelValue="form.code" placeholder="请输入编号" labelWidth="40%"
                                @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                    />
                    <a-space>
                        <ButtonField text="查询" @click="query" secondary/>
                        <ButtonField text="重置" primary @click="reset"/>
                    </a-space>
                </div>
            </a-col>
            <a-col :span="8">
              <div class="right" style="margin-top: 4px">
                <a-space>
                  <ImportExcel category="well" @refresh="reset" />
                  <ButtonField text="下载模版" @click="download" secondary />
                  <ButtonField text="新增" primary @click="setView('新增检查井')"/>
                </a-space>
              </div>
            </a-col>
          </div>
      </a-row>

      <div style="margin-bottom: 16px"></div>
        <Tablelist
                :showCheckbox="false"
                :list="list"
                :columns="tableColumns"
                :totalSize="totalSize"
                :totalPages="totalPages"
                :pageNum="pageNum"
                :pageSize="pageSize"
                @page-change="onChange"
        >
            <template #template-category="{ item }">
                <DataDictFinder dictType="pipeType" :dictValue="item.category" iconType="text" />
            </template>
            <template #template-type="{ item }">
                <DataDictFinder dictType="wellType" :dictValue="item.type" />
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a @click="setRecord(item)">维保记录</a>
                    <a @click.stop="edit(item)">编辑</a>
                    <a class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
      <div v-if="list.length === 0" style="padding-bottom: 16px"></div>
    </div>
  </div>
</template>
<script>
import store from "../mixins/store";
import ImportExcel from "../components/ImportExcel";
import Record from "./record.vue";
import { fetchList, del } from "@/api/assets/inspectWell";
import { mapGetters } from "vuex";

import Tablelist from "@/components/water-affairs-style/table-list.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";

export default {
  mixins: [store],

  components: {
    ImportExcel,Record,Tablelist,InputField,SelectField,ButtonField
  },
  data() {
    return {
      form: {},
      list: [],
      loading: false,
      totalSize: 1,
      totalPages: 1,
      pageNum: 1,
      pageSize: 10,
      record: {},
      tableColumns:[
        {
            key: 'code',
            title: '编号',
            field: 'code',
            infotype: 'text',
            width: '150px'
        },
        {
            key: 'category',
            title: '所属管网',
            field: 'category',
            infotype: 'template',
            width: '100px'
        },
        {
            key: 'elevation',
            title: '地面高程(m)',
            field: 'elevation',
            infotype: 'text',
            width: '100px'
        },
        {
            key: 'materialCover',
            title: '井盖材质',
            field: 'materialCover',
            infotype: 'text',
            width: '100px'
        },
        {
            key: 'materialWell',
            title: '检查井材质',
            field: 'materialWell',
            infotype: 'text',
            width: '100px'
        },
        {
            key: 'shapeCover',
            title: '井盖形状',
            field: 'shapeCover',
            infotype: 'text',
            width: '100px'
        },
        {
            key: 'type',
            title: '井类型',
            field: 'type',
            infotype: 'template',
            width: '100px'
        },
        {
            key: 'diameterRoom',
            title: '井室直径',
            field: 'diameterRoom',
            infotype: 'text',
            width: '100px'
        },
        {
            key: 'diameterCover',
            title: '井盖直径(mm)',
            field: 'diameterCover',
            infotype: 'text',
            width: '100px'
        },
        {
            key: 'actions',
            title: '操作',
            infotype: 'template',
            width: '200px',
            fixed: 'right',
        }
      ]
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("pipeType");
    },
  },
  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    download() {
      window.open(
        "https://qiniu.njszy.com/iot/production/template/%E6%A3%80%E6%9F%A5%E4%BA%95-%E6%A8%A1%E6%9D%BF.xls"
      );
    },
    getList() {
      this.loading = true;
      let { form } = this;

      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageSize = 10;
      this.getList();
    },

    edit(row) {
      this.select({
        ...row,
        _edit: true,
      });
      this.setView("修改检查井");
    },

    select(row) {
      this.setSelectedWell({
        ...row,
        _change: true,
      });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除这个检查井吗？",
        onOk() {
          del({
            id: text.id,
            category: text.category,
          }).then(async () => {
            that.getList();
            if (text.category === "rain") {
              that.getRainWellList();
            } else if (text.category === "sewage") {
              that.getSewageWellList();
            }
          });
        },
      });
    },

    setRecord(text) {
      this.record = text;
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}
</style>